import { atom } from "recoil";

export const CampaignActionAtom = atom<"create" | "edit">({
  key: "CampaignActionAtom",
  default: "create",
});
